"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../");
var AuthLayout = function (_a) {
    var dusk = _a.dusk, children = _a.children;
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: "flex content-center items-center justify-center min-h-screen relative" },
        react_1.default.createElement("div", { className: "app-layout__bg" }),
        react_1.default.createElement("div", { className: "w-full max-w-sm mx-auto relative z-10 py-8" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(__1.ConnectuLogo, { className: "w-auto mb-6" })),
            children)));
};
exports.default = AuthLayout;
//# sourceMappingURL=AuthLayout.js.map